export default __webpack_public_path__ + "static/media/TheWorldMexico_02.83d63bbb.png";